import _ from 'lodash';

const filterUserWithRoleRep = (state) => {
  let repUsers = [];
  _.forEach(state.users, user=>{
    if(_.find(user.roles, r=>{ return r.name=="Rep"}) && user.active === true){
      repUsers.push(user);
    }
  })
  return repUsers;
};

const getUserById = (state) => (userIdsArray) => {
  const users = [];

  _.forEach(userIdsArray, (id) => {
    const u = _.find(state.users, u => u.id === id);
    if (u != null) {
      users.push(u);
    }
  })
  return users;
}

export default {
  filterUserWithRoleRep,
  getUserById
};
